<input #input
    (dateChange)="onDatePicked($event)"
    (click)="picker.open()"
    (keypress)="$event.preventDefault()"
    [matDatepicker]="picker"
    [value]="value"
    [disabled]="disabled"
    readonly />
<mat-datepicker #picker></mat-datepicker>